import React from 'react';
import { RocketIcon, LandmarkIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { pillars } from '../data/content';
const icons = [RocketIcon, LandmarkIcon];
export function SolutionSection() {
  return <section className="relative w-full overflow-hidden bg-navy-800 py-20 lg:py-24" aria-labelledby="solution-heading" style={{
    paddingTop: "21px",
    paddingBottom: "21px"
  }} data-id="element-185" data-mp="3oabybomzuclm">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 grid-pattern opacity-60" data-id="element-186" data-mp="142qdd9nkwxy" />

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8" data-id="element-187" data-mp="3t96pbdv477gt">
        <Reveal className="max-w-3xl" data-id="element-188" data-mp="3t6ken5cxgbud">
          <h2 id="solution-heading" className="text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-189" data-mp="aunrb7csudk1">
            The complete AI transformation system for modern agents
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-slate-300" data-id="element-190" data-mp="ktd8exwvftz8">
            Not a course. Not theory. A proven five-part operational system — with five high-value bonuses — that
            runs your business while you sell.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2" data-id="element-191" data-mp="3b9firi7div5p">
          {pillars.map((pillar, i) => {
          const Icon = icons[i];
          return <Reveal key={pillar.title} delay={i * 0.06} className="h-full" data-id="element-192" data-mp="3f9r0on8cqhdh" data-mpi={i}>
                <article className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.04] p-8 transition-[background-color,border-color] duration-200 ease-out hover:border-white/20 hover:bg-white/[0.07]" data-id="element-193" data-mp="3kbg8lu0a2exc">
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-gold/15 text-brand-gold" data-id="element-194" data-mp="3u6qeistsr6ge">
                    <Icon aria-hidden="true" className="h-6 w-6" strokeWidth={1.75} data-id="element-195" data-mp="6vh8mm9tyn9a" />
                  </span>
                  <h3 className="mt-6 text-xl font-bold text-white" data-id="element-196" data-mp="butx1bgco2dz">{pillar.title}</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-slate-300" data-id="element-197" data-mp="gtoea8yo5ivz">{pillar.description}</p>
                </article>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}